import React from 'react';

import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ExpandedList4Icon(): JSX.Element {
  return (
    <SvgIcon style={{ height: 90, width: 62 }} viewBox="0 0 62 83">
      <g fill="none" fillRule="evenodd">
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -4)"
        >
          <tspan x="0" y="13">
            A.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -4)"
        >
          <tspan x="0" y="85">
            B.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -4)"
        >
          <tspan x="11" y="30">
            a.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -4)"
        >
          <tspan x="11" y="48">
            b.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -4)"
        >
          <tspan x="22" y="66">
            i.
          </tspan>
        </text>
        <path
          d="M16 8H62V10H16zM16 80H62V82H16zM26 25H62V27H26zM26 43H62V45H26zM33 61H62V63H33z"
          fill={IconColors.Grey}
          transform="translate(0 -4)"
        />
      </g>
    </SvgIcon>
  );
}
